import Bluebird from 'bluebird';
import * as taxDocumentsApi from '../api/taxDocuments';
import { downloadFileByURL } from '../helpers/files';
import snackbarHelper from '../helpers/snackbarHelper';

export const REQUEST_TAX_DOCUMENTS = 'REQUEST_TAX_DOCUMENTS';
export const RECEIVE_TAX_DOCUMENTS = 'RECEIVE_TAX_DOCUMENTS';

export const requestTaxDocuments = () => ({
  type: REQUEST_TAX_DOCUMENTS,
});

export const receiveTaxDocuments = (taxDocuments) => ({
  type: RECEIVE_TAX_DOCUMENTS,
  taxDocuments,
  receivedAt: Date.now(),
});

export const fetchTaxDocuments = (params) => (dispatch) => {
  dispatch(requestTaxDocuments());

  return Bluebird.try(() => taxDocumentsApi.getTaxDocuments(params))
    .then((res) => res.json())
    .then((json) => dispatch(receiveTaxDocuments(json.data)))
    .catch((error) => {
      // clear the inflight flag so the table stops loading and falls through to the empty state
      dispatch(receiveTaxDocuments([]));

      // api.js already surfaces its own snackbar for 403s
      if (error && error.statusCode === 403) {
        return null;
      }

      return snackbarHelper.error('Unable to load tax documents. Please try again.');
    });
};

export const downloadTaxDocument = (taxDocument) => () => {
  let objectUrl = null;

  return Bluebird.try(() => taxDocumentsApi.downloadTaxDocument(taxDocument.food_donor_id, taxDocument.year))
    .then((res) => res.blob())
    .then((blob) => {
      objectUrl = URL.createObjectURL(blob);

      return downloadFileByURL({ url: objectUrl, fileName: `${taxDocument.name}.pdf` });
    })
    .catch(() => snackbarHelper.error('Unable to download the tax document. Please try again.'))
    .finally(() => {
      if (objectUrl) {
        // revoking the object URL synchronously right after the click can cancel the download in some browsers
        setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
      }
    });
};
